
import { interpret } from 'xstate';
import { toggleMachine } from '../machines/ToggleMachine';

export class StateMachineManager {
  static _instance = null;
  toggleMachine = null;
  service = null;
  callbacks = [];

  constructor() {
    this.toggleMachine = interpret(toggleMachine);
    this.service = this.toggleMachine.onTransition(current => {
      if (this.callbacks.length > 0) {
        this.callbacks.forEach(callback => {
          callback(current);
        })
      }
    });
  }

  startService() {
    this.service.start();
    this.callbacks = [];
  }

  stopService() {
    this.service.stop();
    this.callbacks = [];
  }

  setChangeStateHandler(callback) {
    this.callbacks.push(callback);
  }

  static get Instance() {
    return this._instance || (this._instance = new this());
  }
};
